import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, LockIcon, FileTextIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-black py-3 md:py-10 px-4 overflow-hidden" data-id="element-87">
      <div className="max-w-4xl mx-auto text-center" data-id="element-88">
        <h1 className="text-[15px] md:text-4xl lg:text-5xl font-extrabold text-white leading-[1.1] mb-2 md:mb-4" data-id="element-89">
          ⭐ El recurso #1 para Aprender{' '}
          <span className="text-[#f97316] italic" data-id="element-90">Herrería y Carpintería</span>{' '}
          ⭐
        </h1>

        <p className="text-[#f97316] font-bold text-sm md:text-xl italic mb-2 md:mb-3" data-id="element-91">
          💰 Aprendé a construir y vender MUEBLES, MÁQUINAS DE GYM, TRAILERS Y
          PROYECTOS CON ACERO Y MADERA y generá entre 1.000 y 2.000 USD en 30
          días con tus propias manos
        </p>

        <div className="my-3 md:my-6 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" onClick={scrollToPricing} data-id="element-92">
          <img src="https://cdn.magicpatterns.com/uploads/dFhGew748JLKUnrfH4tA8A/conjunto_de_mockups_turismo_(1).png" alt="Mega Pack Acero y Madera" className="w-full max-w-2xl mx-auto drop-shadow-2xl" data-id="element-93" />
        </div>

        <p className="text-gray-300 text-sm md:text-lg mb-3 md:mb-6 max-w-2xl mx-auto" data-id="element-94">
          Herrería y carpintería: dos oficios que se venden todo el año, en un
          solo sistema. Accedé a planos profesionales, guías paso a paso y
          materiales listos para usar.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 mb-3 md:mb-6" data-id="element-95">
          <span className="flex items-center gap-1.5 text-gray-400 text-xs md:text-sm font-semibold whitespace-nowrap" data-id="element-96">
            <FileTextIcon className="w-4 h-4 text-[#f97316]" data-id="element-97" /> 100+ PDF
          </span>
          <span className="hidden md:inline text-gray-600 text-xs" data-id="element-98">•</span>
          <span className="flex items-center gap-1.5 text-gray-400 text-xs md:text-sm font-semibold whitespace-nowrap" data-id="element-99">
            <LockIcon className="w-4 h-4 text-[#f97316]" data-id="element-100" /> Acceso ilimitado
          </span>
          <span className="hidden md:inline text-gray-600 text-xs" data-id="element-101">•</span>
          <span className="flex items-center gap-1.5 text-gray-400 text-xs md:text-sm font-semibold whitespace-nowrap" data-id="element-102">
            <ShieldCheckIcon className="w-4 h-4 text-[#f97316]" data-id="element-103" /> Garantía 7
            días
          </span>
        </div>

        <div className="flex justify-center mb-2 md:mb-4" data-id="element-104">
          <CTAButton onClick={scrollToPricing} className="w-full md:w-auto text-base md:text-lg px-8 py-4 whitespace-nowrap" data-id="element-105">
            → QUIERO EL MEGA PACK AHORA
          </CTAButton>
        </div>

        <div className="inline-block bg-yellow-400 text-black font-bold px-4 py-1.5 rounded-full text-xs md:text-sm uppercase tracking-wider" data-id="element-106">
          Pagarás en la moneda de tu país
        </div>
      </div>
    </section>;
}